import { SHARING_VARIANT } from 'reactApp/components/SharingWindow/blocks/Weblink/WeblinkList/SharingNewWeblinkList.types';
import type { PublishItem } from 'reactApp/modules/modifying/modifying.types';
import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

interface RenderUnpublishWeblinkDialogOptions {
    onActionClick: () => void;
    item?: PublishItem;
    isAlbum?: boolean;
    variant?: SHARING_VARIANT;
}

const getDescriptionPart = (item, isAlbum) => {
    if (isAlbum) {
        return 'этот альбом';
    }

    if (item?.isFolder) {
        return 'эта папка';
    }

    return 'этот файл';
};

export const renderUnpublishWeblinkDialog = ({
    onActionClick,
    item,
    isAlbum,
    variant = SHARING_VARIANT.default,
}: RenderUnpublishWeblinkDialogOptions) => {
    let id;
    let title;
    let description;
    let buttonAcceptText;
    let buttonRejectText;
    let hideCheckbox = false;
    let compactButtons = false;

    switch (variant) {
        case SHARING_VARIANT.files:
        case SHARING_VARIANT.filesBiz:
            id = 'weblink-warning-dialog';
            title = 'Закрыть доступ к файлу?';
            description =
                'Текущая ссылка перестанет работать у всех —\nу добавленных пользователей тоже. Вы сможете создать новую, если потребуется';
            buttonAcceptText = 'Закрыть доступ';
            buttonRejectText = 'Не закрывать';

            hideCheckbox = true;
            compactButtons = true;
            break;

        case SHARING_VARIANT.folders:
        case SHARING_VARIANT.foldersBiz:
            id = 'weblink-tab-warning-dialog';
            title = 'Закрыть доступ к папке?';
            description = 'Текущая ссылка перестанет работать. Вы сможете создать новую, если потребуется';
            buttonAcceptText = 'Закрыть';
            buttonRejectText = 'Не отключать';

            hideCheckbox = true;
            compactButtons = true;
            break;

        case SHARING_VARIANT.default:
        default:
            id = 'weblink-warning-dialog';
            title = 'Вы действительно хотите отключить доступ по ссылке?';

            description = `После отключения ${getDescriptionPart(item, isAlbum)} перестанет быть ${
                item?.isFolder && !isAlbum ? 'доступной' : 'доступным'
            } для пользователей, у которых была ссылка`;

            buttonAcceptText = 'Отключить';
            buttonRejectText = 'Не отключать';
    }

    openPopupHelper({
        popupName: popupNames.NO_WARNING,
        data: {
            hideCheckbox,
            compactButtons,
            onActionClick,
            id,
            title,
            description,
            buttonAcceptText,
            buttonRejectText,
        },
    });
};
